export const GLASS_CLASSES =
  'inline-flex items-center justify-center size-10 rounded-full backdrop-blur-[20px] bg-white/80 border border-white/60 shadow-[0_8px_24px_rgba(0,0,0,0.1)] transition hover:brightness-90';
